export const TOGGLE_SATURATION = 'TOGGLE_SATURATION';
export const TOGGLE_HEATMAP = 'TOGGLE_HEATMAP';
export const GET_SATURATION = 'GET_SATURATION';
export const GET_SATURATION_ERROR = 'GET_SATURATION_ERROR';
export const SET_SATURATION = 'SET_SATURATION';
export const TOGGLE_SATURATION_AUTOREFRESH = 'TOGGLE_SATURATION_AUTOREFRESH';
export const SET_SELECTED_SATURATION = 'SET_SELECTED_SATURATION';
export const SET_SELECTED_HEATSATURATION = 'SET_SELECTED_HEATSATURATION';
export const GET_SATURATION_RULES = 'GET_SATURATION_RULES';
export const GET_HEATMAP_DATA = 'GET_HEATMAP_DATA';
export const GET_HEATMAP_ERROR = 'GET_HEATMAP_ERROR';
